import React from "react";
import {Filter} from "admin-on-rest";
import TextInput from "../../../components/CRM/TextInput";
import DateInput from "../../../components/CRM/DateInput";

const ReportFilter = props => (
  <Filter {...props}>
    <DateInput label="resources.devices.fields.timestamp" source="created_at_on_date" />
    <TextInput
      label="resources.devices.fields.wifiConnectionName"
      source="wifi_name_like"
    />
  </Filter>
);

export default ReportFilter;



// WEBPACK FOOTER //
// ./src/containers/CRM/Devices/ReportFilter.js